module.exports = __webpack_public_path__ + "static/img/invest_pass_image.9e36bd6.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/invest_pass_image.png
// module id = mruG
// module chunks = 4